import { RoomFormPage } from '@/components/RoomFormPage'

export const AdminEditRoomPage = () => <RoomFormPage mode="edit" />
